import { lazy } from "react";
import Layout from "../layout";
import ROUTES from "../constants/routes";
import LandingPage from "../admin/pages/LandingPage";
import ProtectedRoute from "./ProtectedRoute";

const Home = lazy(() => import("../pages/Home"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Country = lazy(() => import("../pages/Country"));
const FtcDatasets = lazy(() => import("../pages/Datasets/FtcDatasets"));
const About = lazy(() => import("../pages/About"));
const CountrySpecificPage = lazy(
  () => import("../pages/Country/CountrySpecificPage")
);

const routes = [
  {
    path: ROUTES.HOME,
    element: (
      <ProtectedRoute>
        <Layout>
          <Home />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: `${ROUTES.DATASETS}${ROUTES.FTC_DATASETS}`,
    element: (
      <ProtectedRoute>
        <Layout>
          <FtcDatasets />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.COUNTRIES,
    element: (
      <ProtectedRoute>
        <Layout>
          <Country />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: `${ROUTES.COUNTRIES}/:countryIsoCode/`,
    element: (
      <ProtectedRoute>
        <Layout>
          <CountrySpecificPage />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.ABOUT,
    element: (
      <ProtectedRoute>
        <Layout>
          <About />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.ADMIN_LANDING_PAGE,
    element: (
      <ProtectedRoute>
        <LandingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: (
      <ProtectedRoute>
        <Layout>
          <NotFound />
        </Layout>
      </ProtectedRoute>
    ),
  },
];

export default routes;
